/**
 * Domínio do colchão.
 * Unidade interna: mm. Exibição ao usuário em cm via utils.
 */
/** Versão do schema — usada para migrações futuras */
export const MATTRESS_SCHEMA_VERSION = 2;
/** Presets de dimensão padrão da indústria BR */
export const DIMENSION_PRESETS = {
    solteiro: { larguraMm: 880, comprimentoMm: 1880, label: 'Solteiro 88×188' },
    solteiroKing: { larguraMm: 960, comprimentoMm: 2030, label: 'Solteiro King 96×203' },
    casal: { larguraMm: 1380, comprimentoMm: 1880, label: 'Casal 138×188' },
    queen: { larguraMm: 1580, comprimentoMm: 1980, label: 'Queen 158×198' },
    king: { larguraMm: 1930, comprimentoMm: 2030, label: 'King 193×203' },
    superKing: { larguraMm: 1930, comprimentoMm: 2230, label: 'Super King 193×223' },
};
